import { IMyHomeStatusInfoSchema } from '../../repositories/price-estimator/entities/thin_client_info/MyHomeStatusInfoSchema';
import { IApplicationState } from '../../types/redux';
import { EStatusLoad } from '../../types/redux/status';

export function selectStatusList(state: IApplicationState): IMyHomeStatusInfoSchema[] {
  return state.status.data;
}

export function selectStatusLoad(state: IApplicationState): EStatusLoad {
  return state.status.statusLoad;
}

export function selectStatusModalOpen(state: IApplicationState): boolean {
  return state.status.modalOpen;
}

export function selectCurrentStatus(state: IApplicationState): IMyHomeStatusInfoSchema | undefined {
  return state.status.currentStatus;
}
